import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SessionType, newUuid } from '@shared';
import {
  selectClient,
  selectSession,
  selectClientOnboardingSlideProgress,
  putClientOnboardingSlideProgressByClientIdRequest,
} from '@/model';

import { CLIENT_COMPLETED_REVIEW } from '@client';

export function useOnboardingCompletion(clientId: string) {
  const dispatch = useDispatch();
  const client = useSelector(selectClient)!;
  const { sessionType } = useSelector(selectSession);
  const onboardingSlideProgress = useSelector(selectClientOnboardingSlideProgress);

  useEffect(() => {
    if (
      (onboardingSlideProgress && onboardingSlideProgress.hasClientCompletedOnboarding) ||
      sessionType !== SessionType.client
    ) {
      return;
    }

    const clientOnboardingSlideProgressId =
      onboardingSlideProgress?.clientOnboardingSlideProgressId ?? newUuid();
    const updatedClientTags = [...client.clientTags, CLIENT_COMPLETED_REVIEW];

    dispatch(
      putClientOnboardingSlideProgressByClientIdRequest({
        clientOnboardingSlideProgressId,
        clientId,
        hasClientCompletedOnboarding: true,
        clientTags: updatedClientTags,
      }),
    );
  }, [clientId, dispatch, sessionType]);
}
